import { ArrowDownOutlined, ArrowUpOutlined, MoneyCollectTwoTone } from '@ant-design/icons';
import { Button, Drawer, Table } from 'antd';
import axios from 'axios';
import React, { useEffect, useState } from 'react';

function ValKurses() {
    let [vals, setVals] = useState([])
    let [open, setOpen] = useState(false)

    useEffect(() => {
        axios.get('valkurs').then(data => {
            setVals(data.data)
        })
    }, [])

    let columns = [
        {
            title: "Valuta",
            dataIndex: "CcyNm_UZ",
            key: "CcyNm_UZ",
        },
        {
            title: "Narxi",
            dataIndex: "Rate",
            key: "Rate",
            render: (text, record) => {
                return <p style={{textAlign: 'right', width: '100%'}}>{text}</p>
            }
        },
        {
            title: "Farq",
            dataIndex: "Diff",
            key: "Diff",
            render: (text, record) => {
                return <span style={{ color: text > 0 ? 'green' : 'red' }}>{text} { text > 0 ? <ArrowUpOutlined style={{ color: 'green' }} /> : <ArrowDownOutlined style={{ color: 'red' }} />}</span>
            }
        }
    ]

    return (
        <>
            <Drawer title="Valuta kurslari" width={500}  open={open} onClose={() => { setOpen(false) }}>
                <Table columns={columns} size='small' bordered dataSource={vals} rowKey="id" pagination={false} />
            </Drawer>
            <Button icon={<MoneyCollectTwoTone />} type='primary' style={{ backgroundColor: 'indigo' }} onClick={() => { setOpen(true) }} />
        </>
    );
}

export default ValKurses;